var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlackquestion = function SvgBlackquestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#000",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.628 18.668c3.137-.209 5.636-2.743 5.842-5.925.04-.623.04-1.267 0-1.89-.206-3.182-2.705-5.716-5.842-5.925a25 25 0 0 0-3.256 0c-3.137.209-5.636 2.743-5.842 5.925-.04.623-.04 1.268 0 1.89.075 1.159.588 2.232 1.19 3.138.351.634.12 1.426-.245 2.117-.263.499-.394.748-.289.928s.342.186.814.198c.933.022 1.562-.242 2.062-.61.283-.21.424-.314.522-.326s.29.067.674.226c.345.142.746.23 1.114.254 1.068.07 2.186.071 3.256 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M10.875 10.154C10.875 9.517 11.379 9 12 9s1.125.517 1.125 1.154c0 .23-.066.444-.178.623-.336.536-.947 1.047-.947 1.685v.288"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 14.25h.008"
  })));
};
export default SvgBlackquestion;